import { stringify } from 'flatted';

export const serializeError = (value: unknown): string => stringify(value);
